<div class="note-container">
  <div class="note-header">
    <div class="actions">
      <img alt="close" [src]="'images/close_grey.svg' | assetUrl" class="white-icon cursor-pointer"
        draggable="false" (click)="closeNote()" (keypress)="closeNote()">
      </div>
      @if (fileSaved || !isLoginUserIsCreatorOfNote) {
        <span class="note-header-name">{{noteName.value}}</span>
      }
      @else {
      <input placeholder="Name" [formControl]="noteName">
    }

    @if (!fileSaved) {
      <div class="actions button-group">
        <button mat-button (click)="saveNote()">Save</button>
        <!-- <button mat-button [matMenuTriggerFor]="saveMenu" class="save-menu-btn">
        <img [src]="'images/caret_down.svg' | assetUrl" class="cursor-pointer" draggable="false">
      </button> -->
      <!-- <mat-menu #saveMenu="matMenu" xPosition="before" class="actions-menu version-actions-panel">
      <button class="mat-menu-item-button" mat-menu-item (click)="saveNote('draft')" class="save-menu-item">
        Save draft
      </button>
      <button mat-menu-item (click)="discardNote()" *ngIf="note?.draftSaved" class="save-menu-item">
        Discard changes
      </button>
    </mat-menu> -->
  </div>
}
@if (fileSaved) {
  <div>
    <span class="icon-mr-5">
      <img alt="pencil" [src]="'images/pencil.svg' | assetUrl" class="icon-mr-5 cursor-pointer"
        (click)="editNote()" (keypress)="editNote()" draggable="false" />
      </span>
      <span [matMenuTriggerFor]="editNoteMenu" overlapTrigger="true">
        <img alt="more" [src]="'images/more.svg' | assetUrl" class="white-more cursor-pointer"
          draggable="false" />
        </span>
        <mat-menu #editNoteMenu="matMenu" class="actions-menu note-menu" xPosition="before">
          @for (item of noteActionsList; track item) {
            <button class="mat-menu-item-button" mat-menu-item (click)="handleAction(item.name)"
              [ngClass]="{ 'action-border-botton': item?.name === 'openLocation'&& noteActionsList?.length > 2 }">
              @if (item?.icon) {
                <mat-icon [class]="item.menuItemClasses">{{
                  item.icon
                }}</mat-icon>
              }
              @if (item?.imgUrl) {
                <img [src]="'images/' + item.imgUrl + '.svg' | assetUrl"
                  alt="{{ item.imgUrl }} icon" [class]="item.menuItemClasses" draggable="false" />
              }
              {{ item.displayName }}
            </button>
          }
        </mat-menu>
      </div>
    }
  </div>
  <div class="editor-content">
    <div [ngStyle]="{'width': showAttachmentsDrawer ? '75%' : '100%'}" class="editor">
      @if (!fileSaved) {
        <quill-editor class="note-editor" [placeholder]="''" [formControl]="control">
        </quill-editor>
      }
      @if (fileSaved && currentNote) {
        <div class="note-editor version-mode"
          [innerHTML]="sanitizer.bypassSecurityTrustHtml(currentNote.content)">
        </div>
      }
    </div>
    @if (showAttachmentsDrawer) {
      <div class="attachments-drawer">
        <!-- (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)" (drop)="onFileDrop($event)" [ngClass]="{'drag-over': draggedOver}" -->
        <div class="nav-tabs">
          @for (tab of tabs; track tab) {
            <div class="header" [ngClass]="{'active': currentTab===tab}"
            (click)="currentTab = tab;" (keypress)="currentTab = tab;" >{{tab}}</div>
          }
        </div>
        @if (currentTab === 'attachments' && draggedOver) {
          <div class="note-drag-text">
            Drop files here.
          </div>
        }
        @if (currentTab === 'attachments') {
          <div class="files-list-container">
            @for (file of note.attachments; track file) {
              <div class="file">
                <div class="file-icon">
                  @if (file.type !== 'folder') {
                    <img alt="image" draggable="false"
                      [src]="'images/' + imageMapper?.[file.type] + '.svg' | assetUrl" />
                  }
                </div>
                <div class="file-details">
                  <h6>{{file?.name}}.{{file?.type}}</h6>
                  <small>{{file?.size}}</small>
                </div>
                <div class="file-actions" (click)="$event.stopPropagation()" (keypress)="$event.stopPropagation()">
                  <span [matMenuTriggerFor]="fileActionsMenu" class="hover-black" overlapTrigger="true">
                    <img alt="more" [src]="'images/more.svg' | assetUrl" draggable="false" />
                  </span>
                  <mat-menu #fileActionsMenu="matMenu" class="actions-menu" xPosition="before">
                    <button class="mat-menu-item-button" mat-menu-item (click)="deleteAttachedFile(file)">
                      <img alt="trash" [src]="'images/trash.svg' | assetUrl" class="icon-mr-5"
                        draggable="false" />
                        Trash
                      </button>
                    </mat-menu>
                  </div>
                </div>
              }
            </div>
            <div class="attachments-container">
              <span class="drag-drop-msg">
                Drag and drop files here or
              </span>
              <span class="upload-file" [matMenuTriggerFor]="uploadMenu">
                click to upload
              </span>
              <mat-menu #uploadMenu="matMenu" class="upload-fab-panel attachments-panel" xPosition="before">
                <input #noteFileUpload id="noteFileUpload" multiple
                  (change)="onFileChange($any($event)?.target?.files)" type="file" />
                  <button class="mat-menu-item-button" mat-menu-item>
                    <label for="noteFileUpload">
                      <img alt="computer" [src]="'images/computer.svg' | assetUrl" draggable="false"
                        class="icon-mr-5" />
                        Your computer
                      </label>
                    </button>
                  </mat-menu>
                </div>
              } @else {
                <div class="versions-list">
                  @for (version of note?.versions; track version.contentCreatedAt; let first = $first) {
                    <div class="version-item"
                      [ngStyle]="{'background-color': version.contentCreatedAt === currentNote.contentCreatedAt ? '#cae9f7' : ''}"
                      (click)="setCurrentViewingVersion(version, $event)" (keypress)="setCurrentViewingVersion(version, $event)">
                      <img alt="file document" [src]="'images/file_document.svg' | assetUrl" draggable="false">
                      <div class="version-details">
                        <div>{{version.createdAt + "Z" | date:'MM/dd/yyyy h:mm a'}}&nbsp;
                          @if (first) {
                            <span class="current-badge">current</span>
                          }
                        </div>
                        <small>
                          by <span class="user-name" (click)="openUserDetailsDialog(version)" (keypress)="openUserDetailsDialog(version)">{{version.user ?
                        version.user.userName : note.createdByName}}</span>
                      </small>
                    </div>
                    @if (!first) {
                      <div class="version-actions" (click)="$event.stopPropagation()" (keypress)="$event.stopPropagation()">
                        <span [matMenuTriggerFor]="versionMenu" class="hover-black" overlapTrigger="true">
                          <img alt="more" [src]="'images/more.svg' | assetUrl" draggable="false" />
                        </span>
                        <mat-menu #versionMenu="matMenu" class="actions-menu version-actions-panel"
                          xPosition="before">
                          <button class="mat-menu-item-button" mat-menu-item (click)="revertVersion(version)">
                            <img alt="undo" [src]="'images/undo.svg' | assetUrl" class="icon-mr-1"
                              draggable="false">
                              Revert
                            </button>
                            @if (version.createdBy === this.data.loggedUser.id) {
                              <button mat-menu-item (click)="removeVersion(version)">
                                <img alt="close" [src]="'images/close_grey.svg' | assetUrl" class="icon-mr-1"
                                  draggable="false">
                                  Remove
                                </button>
                              }
                            </mat-menu>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>

        @if (showLoader) {
          <collaboration-ui-spinner [overlay]="true"></collaboration-ui-spinner>
        }